<template>
  <v-app>
    <section id="menu-wrapper" :class="{ 'menu-expanded' : $store.state.menuOpen }">
      <side-menu></side-menu>
    </section>

    <section id="content-wrapper" :class="{ 'menu-expanded' : $store.state.menuOpen }">
      <v-toolbar class="header-toolbar" :class="{ 'menu-expanded' : $store.state.menuOpen }" :color="companyPrimaryColor" fixed dense dark>
        <v-toolbar-title class="white--text">Prijslijst</v-toolbar-title>
      </v-toolbar>

      <section id="content" class="pricelist">
        <div class="content-header-extra"></div>

        <div class="content-box-log">
          <section id="header">
            <div class="pricelist-header clear">
              <v-stepper v-model="e1" >
                <v-stepper-header>
                  <v-stepper-step :complete="e1 > 1" step="1" editable dark color="#50EB94" >Dames / Heren / Kids </v-stepper-step>
                  <v-divider></v-divider>
                  <v-stepper-step :complete="e1 > 2" step="2" @click.native="resetTitle();" editable dark color="#50EB94" >Haarlengtes</v-stepper-step>
                  <v-divider></v-divider>
                  <v-stepper-step step="3" dark color="#50EB94" >Behandelingen</v-stepper-step>
                </v-stepper-header>
              </v-stepper>
            </div>
          </section>

          <section class="pricelist-wrapper">

            <v-stepper v-model="e1">
              <v-stepper-items> 
                <v-stepper-content step="1">
                  <v-container grid-list-xl text-xs-cente >
                    <v-layout row justify-space-between>
                      
                      <v-flex xs12  md4 class="select-client-type text-xs-center" @click.stop=" resetAll(); e1 = 2; editable_stepper = true;" > 
                        <img src="https://drupal.hairbeautycompany.nl/themes/custom/greenpower/img/pages/hbc-dames-kort@2x.png" >
                        <v-btn round depressed dark color="#50EB94">Dames </v-btn>
                      </v-flex>

                      <v-flex xs12  md4 class="select-client-type text-xs-center" @click.stop="resetAll(); e1 = 3; editable_stepper = false; getTreatments(chosenHairlength.male[0]); getTreatments_discount(); " >
                        <img src="https://drupal.hairbeautycompany.nl/themes/custom/greenpower/img/pages/hbc-heren-prijzen@2x.png" >
                        <v-btn round depressed dark color="#50EB94">Heren </v-btn>
                      </v-flex>

                      <v-flex xs12 md4 class="select-client-type text-xs-center" @click.stop="resetAll(); e1 = 3; editable_stepper = false; getTreatments(chosenHairlength.kids[0]); getTreatments_discount(); " >
                        <img src="https://drupal.hairbeautycompany.nl/themes/custom/greenpower/img/pages/hbc-kids-prijzen@2x.png" >
                        <v-btn round depressed dark color="#50EB94" >Kids </v-btn>
                      </v-flex>

                    </v-layout>
                  </v-container>
                </v-stepper-content>

                <v-stepper-content step="2">
                  <v-container color="white" grid-list-xl text-xs-center>
                    <v-layout row wrap justify-space-between align-content-center>

                      <v-flex xs12 sm5 md3 class="select-client-type" @click.stop="resetAll(); e1 = 3; getTreatments(chosenHairlength.female[0]); getTreatments_discount(); ">
                        <img src="https://drupal.hairbeautycompany.nl/themes/custom/greenpower/img/pages/hbc-dames-kort@2x.png" >
                        <v-btn round depressed dark color="#50EB94">Kort </v-btn>
                      </v-flex>

                      <v-flex xs12 sm5 md3 class="select-client-type"  @click.stop="resetAll(); e1 = 3; getTreatments(chosenHairlength.female[1]); getTreatments_discount(); ">
                        <img src="https://drupal.hairbeautycompany.nl/themes/custom/greenpower/img/pages/hbc-dames-half@2x.png" >
                        <v-btn round depressed dark color="#50EB94">half-lang </v-btn>
                      </v-flex>

                      <v-flex xs12 sm5 md3 class="select-client-type" @click.stop="resetAll(); e1 = 3; getTreatments(chosenHairlength.female[2]); getTreatments_discount(); ">
                        <img src="https://drupal.hairbeautycompany.nl/themes/custom/greenpower/img/pages/hbc-dames-lang@2x.png" >
                        <v-btn round depressed dark color="#50EB94">Lang</v-btn>
                      </v-flex>

                      <v-flex xs12 sm5 md3 class="select-client-type"  @click.stop="resetAll(); e1 = 3; getTreatments(chosenHairlength.female[3]); getTreatments_discount(); ">
                        <img src="https://drupal.hairbeautycompany.nl/themes/custom/greenpower/img/pages/hbc-dames-xl@2x.png" >
                        <v-btn round depressed dark color="#50EB94">XL Lengte </v-btn>
                      </v-flex>

                    </v-layout>
                  </v-container>
                </v-stepper-content>

                <v-stepper-content step="3">
                  <div :class="{wolfload: wolfload}">
                      <div class="blackbox" style="display: none;"> 
                          <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid" class="lds-dual-ring"><circle cx="50" cy="50"   fill="none" stroke-linecap="square" r="40" stroke-width="16" stroke="#FFFFFF" stroke-dasharray="62.83185307179586 62.83185307179586" transform="rotate(359.669 50.0012 50.0012)"><animateTransform attributeName="transform" type="rotate" calcMode="linear" values="0 50 50;360 50 50" keyTimes="0;1" dur="0.5s" begin="0s" repeatCount="indefinite"></animateTransform></circle></svg>
                      </div>
                    </div>  
                  <div class="pricelist-wrapper">
                    <v-container class="no-padding">
                      <v-layout >
                        <v-flex xs5>
                          <v-card>

                            <v-list three-line >
                              <template v-for="(treatment, index) in treatments">
                                <v-list-tile :key="treatment.title" avatar @click=" resetAll();  selectedTreatment = treatment; getTreatment_pins(selectedTreatment.field_pintrest_rss.replace(/^\/|\/$/g, '') ); 
                                  $store.state.TreatmentCalc.prijshoofdbehandeling = selectedTreatment.field_prijs_behandeling;  
                                  $store.state.TreatmentCalc.prijshoofdbehandeling_abo = selectedTreatment.field_views_simple_math_field;"
                                >
                                  <v-list-tile-avatar>
                                    <img :src="company[1] + treatment.field_afbeelding_behandeling">
                                  </v-list-tile-avatar>
                                  <v-list-tile-content>
                                    <v-list-tile-title  v-html="treatment.title"></v-list-tile-title>
                                    <v-list-tile-sub-title v-if="!membershipdiscount" v-html="'€' + treatment.field_prijs_behandeling + ' ' + treatment.field_omschrijving_behandeling "></v-list-tile-sub-title>
                                    <v-list-tile-sub-title v-else v-html="'€' + treatment.field_views_simple_math_field + ' ' + treatment.field_omschrijving_behandeling "></v-list-tile-sub-title>
                                  </v-list-tile-content>
                                </v-list-tile>
                                <v-divider :key="index"></v-divider>
                              </template>
                            </v-list>
                          </v-card>

                        </v-flex>
        
                        <v-flex xs7>
                          <div v-show="selectedTreatment.title" class="selected-treatment-wrapper">
                            <h2 class="selected-treatment-title">{{computeSelectedTreatment}}</h2>
                            <div class="add-extra-button">

                              <app-modalWithTreatment  ref="modalWithTreatment" ></app-modalWithTreatment>
                              <!-- <div style="display: none;"><app-modalProduct ref="modalProduct" ></app-modalProduct></div> -->
                            </div>
                            <v-divider></v-divider>
                            
                            <v-card class="selected-treatment-intro">
                              <v-layout row wrap>
                                <v-flex xs7>
                                  <div class="intro-text-wrapper">
                                    <div class="treatment-desc clear" v-if="selectedTreatment.field_omschrijving_behandeling"><v-icon class="pillar-grey">notes</v-icon><p> {{ selectedTreatment.field_omschrijving_behandeling  }}</p></div>
                                    <div class="recommended-wrapper" v-if="selectedTreatment.field_aanbevolen_behandeling">
                                      <h3>Aanbevolen bijbehandelingen</h3>
                                      <div class="treatment-desc clear"><v-icon color="#50EB94">star</v-icon><p color="primary"> {{ selectedTreatment.field_aanbevolen_behandeling }}</p></div>
                                    </div>

                                    <div class="chosen-wrapper" >
                                      <h3>Gekozen bijbehandelingen</h3>
                                      <div v-if="computeChooseWithTreatment" class="treatment-desc clear"><v-icon color="#50EB94" >check</v-icon><p color="primary"> {{computeChooseWithTreatment}} </p></div>
                                      <!-- <div class="treatment-desc clear"><v-icon class="pillar-grey">star</v-icon><p> {{ selectedTreatment.field_aanbevolen_behandeling }}</p></div> -->
                                    </div>
                                  </div>
                                </v-flex>

                                <v-flex xs5>
                                  <div :class="{wolfload_pic: wolfload_pic}" style="width: 80px; height: 80px; position: fixed; margin-top: 20px; margin-left: 80px;">
                                    <div class="blackbox" style="display: none;"> 
                                      <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid" class="lds-dual-ring"><circle cx="50" cy="50"   fill="none" stroke-linecap="square" r="40" stroke-width="16" stroke="#FFFFFF" stroke-dasharray="62.83185307179586 62.83185307179586" transform="rotate(359.669 50.0012 50.0012)"><animateTransform attributeName="transform" type="rotate" calcMode="linear" values="0 50 50;360 50 50" keyTimes="0;1" dur="0.5s" begin="0s" repeatCount="indefinite"></animateTransform></circle></svg>
                                    </div>
                                  </div> 

                                  <v-carousel v-if="this.showcarousel == true"  style="height: 220px;"  hide-delimiters interval="2000" >
                                    <v-carousel-item  v-for="(item,i) in pins" :src="item.src"   :key="i" reverse-transition="fade" transition="fade"></v-carousel-item>
                                  </v-carousel>
                                </v-flex>
                              </v-layout>
                            </v-card>

                            <v-layout row wrap>
                              
                              <v-flex xs6><h3>Prijs</h3></v-flex>
                              <!-- <v-flex  xs6><h3 style="margin-left: 10px;">Lopende acties behandelingen</h3></v-flex> -->
                    
                              <v-flex d-flex xs12>
                                <v-card class="selected-treatment-price">
                                  <v-layout row wrap>
                                      <v-flex xs6 >
                                        <p>Prijs behandeling:</p>
                                        <p>Bij behandeling:</p>
                                        <p>Product:</p>
                                        <p>Totaal:</p>
                                        <p class="price-discount">Voordeel:</p>
                                        <p class="price-total">Uiteindelijke prijs:</p>
                                        </v-flex>
                                        <v-flex xs6>
                                        <p>€{{selectedTreatment.field_prijs_behandeling}} <span v-show="membershipdiscount"> {{computeConvertPrice[0]}}</span> <span v-if="killradio == true "> {{computeSelectedTreatments_discount_auto}}</span> <!-- <span v-show="!$store.state.selectedTreatment_discount.Treatment_discount_name  == 0"> {{$store.state.selectedTreatment_discount.Treatment_discount_name}}</span> --> </p>
                                        <p >{{computeConvertPrice[1]}} <span  v-show="!$store.state.selectedWithTreatment_discount.WithTreatment_discount_result == 0"> {{computeConvertPrice[2]}}</span> <span >{{$store.state.selectedWithTreatment_discount.WithTreatment_discount_name}}</span></p>
                                        <p>{{computeConvertPrice[3]}} <span v-show="!$store.state.selectedProduct_discount.Product_discount_result  == 0"> {{computeConvertPrice[4]}}</span> <span >{{$store.state.selectedProduct_discount.Product_discount_name}}</span></p>
                                        
                                        <p v-if="!membershipdiscount"  >{{computePrice[0]}} </p>
                                        <p v-else  ><span style="text-decoration: line-through"> {{computePrice[0]}}</span> <span> {{computePrice[4]}} <strong>20%</strong></span></p>
                                        <p class="price-discount"><span >{{computePrice[2]}}</span></p>
                                        <p class="price-total">{{computePrice[1]}} </p>
                                      </v-flex>
                                  </v-layout>
                                </v-card>
                              </v-flex>

                              <v-flex d-flex xs4 >
                                <v-card v-show="this.noradio.title !== 'Geen'" class="selected-treatment-actions">
                                  <v-radio-group v-model="selected_discount" :mandatory="false" column>
                                    <!-- Show Radio group when selected --> 
                                    <v-radio 
                                    label="Geen acties"
                                    @click.native="resetTotalprice(); DeSelectedTreatments();"
                                    :value="noradio"
                                    ></v-radio>

                                    <template v-for="(acties,index2) in loadedTreatments_discounts" >
                                      <v-radio
                                        :key="index2"
                                        :label="acties.title"
                                        :value="acties"
                                        @click.native="resetTotalprice(); computeSelectedTreatments_discount(); killradio_switch();"
                                      ></v-radio>
                                    </template>
                                  </v-radio-group>
                                </v-card>
                              </v-flex>
                            </v-layout>

                            <v-layout row wrap>
                              <v-flex xs6 style="font-size: 14px;">
                                <v-checkbox
                                  color="#50EB94" 
                                  label="Abonnements prijzen"
                                  v-model="membershipdiscount"
                                  @click.native="resetRadiobyMembership(); resetTotalprice();"
                                ></v-checkbox>
                              </v-flex>
                              <v-flex xs6>
                                <v-btn style="margin: 15px 0 0 0; float: right;" color="#50EB94" dark @click.native="e1 = 1; resetAll();" >Klaar</v-btn>
                              </v-flex>
                            </v-layout>
                          </div>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </div>
                </v-stepper-content>
              </v-stepper-items>
            </v-stepper>
          </section>
        </div>
      </section>
    </section>

  </v-app>
</template>
<style>
.wolfload {
  width: 80px;
  height: 80px;
  position: fixed;
  left: 50%;
  top: 50%;
  -webkit-transform: translateX(-50%);
  -webkit-transform: translateY(-50%);
  transform: translateX(-50%);
  transform: translateY(-50%);
}
.container.no-padding {
  padding: 0 !important;
}

.pricelist-items-wrapper {
  position: relative;
}
.pricelist-header {
  width: 100%;
  height: 69px;
  background: #fff;
  border-bottom: 1px solid #e8e9ee;
}
.pricelist-wrapper {
  position: relative;
  width: 100%;
}

.pricelist-wrapper .v-list {
  padding: 0;
}

.intro-text-wrapper {
  padding: 10px;
}
</style>
<script>
import axios from "axios";
import accounting from "accounting";
import modalWithTreatment from "../components/modals/modalWithTreatment.vue";

export default {
  name: "prijslijst",
  components: {
    "app-modalWithTreatment": modalWithTreatment
    // "app-modalProduct": modalProduct,
  },

  props: ["selectedproduct"],
  name: "selectTreatment",

  data: () => ({
    dikkeLeuter: true,
    membershipdiscount: false,
    wolfload: false,
    wolfload_pic: false,
    extraTreatmentModal: false,
    company: ["Hair & Beauty Company", "http://drupal.hairbeautycompany.nl"],
    e1: 1,
    showcarousel: false,
    treatments: {},
    withtreatments: {},
    selectedTreatment: {
      title: "",
      field_omschrijving_behandeling: "",
      field_prijs_behandeling: null,
      field_aanbevolen_behandeling: "",
      firstselect: true
    },

    selectedWithTreatment: {
      field_prijs_behandeling: 12.45,
      field_combiprijs: 10.45
    },

    noradio: {
      field_geldig_met_abo: "False",
      field_korting_in_euro: 0,
      field_korting_in_percentage: 0,
      field_korting_type: "Bedrag",
      field_merken_actie: 0,
      field_type_actie: "Behandeling",
      title: "Geen"
    },
    killradio: false,
    editable_stepper: true,
    selected_treatmentpins: [],

    chosenHairlength: {
      female: ["short", "medium", "long", "long-xl"],
      male: ["men-all"],
      kids: ["kids-all"]
    },
    membershipdiscount: false, //
    loadedTreatments_discounts: [],
    selected: [],
    selected_discount: [],
    pins: []
  }),

  created() {},

  methods: {
    resetTitle() {
      //Kill selected stuff
      this.selectedTreatment.title = "";
    },

    resetAll() {
      console.log("uitvoeren");

      (this.$store.state.membershipdiscount = false), (this.$store.state.priceCalculate.totalprice = null);
      this.$store.state.selectedWithTreatment_discount.WithTreatment_discount_result = null;
      this.$store.state.selectedWithTreatment_discount.WithTreatment_discount_name = null;
      this.$store.state.selectedProduct_discount.Product_discount_result = null;
      this.$store.state.selectedProduct_discount.Product_discount_name = null;
      this.$store.state.selectedTreatment_discount.Treatment_discount = null;
      this.$store.state.selectedTreatment_discount.Treatment_discount_result = null;
      this.$store.state.selectedTreatment_discount.Treatment_discount_name = null;
      this.$store.state.WithTreatmentCalc.TitleTreatment = [];
      this.$store.state.WithTreatmentCalc.prijsbehandeling = 0;
      this.$store.state.ProductCalc.TitleProduct = [];
      this.$store.state.ProductCalc.prijsproduct = 0;
      this.$store.state.TreatmentCalc.TitleTreatment = [];
      this.$store.state.TreatmentCalc.prijshoofdbehandeling = null;
      this.$store.state.TreatmentCalc.prijshoofdbehandeling_abo = null;
      this.$store.state.withTreatmentprice = {};
      this.killradio = false;

      //Radio Switchers
      this.selected_discount = this.noradio; //Throws object to another object
      this.$store.state.selected_discount_product = this.$store.state.radioboxen.noradio;
      this.$store.state.selected_discount_withtreatment = this.$store.state.radioboxen.noradio;
      // this.$refs.modalProduct.resetCheckbox([]);
      this.$refs.modalWithTreatment.resetCheckbox([]);
    },

    resetRadiobyMembership() {
      console.log("test Sven");

      this.selected_discount = this.noradio; //Throws object to another object
      this.$store.state.selected_discount_product = this.$store.state.radioboxen.noradio;
      this.$store.state.selected_discount_withtreatment = this.$store.state.radioboxen.noradio;
    },

    resetTotalprice() {
      this.$store.state.priceCalculate.totalprice = 0;
      this.$store.state.selectedWithTreatment_discount.WithTreatment_discount_result = 0;
      this.$store.state.selectedProduct_discount.Product_discount_result = 0;
      this.$store.state.selectedTreatment_discount.Treatment_discount = 0;
      this.$store.state.selectedTreatment_discount.Treatment_discount_result = 0;
    },

    getTreatments_discount() {
      this.wolfload = true;
      let checkmembership;
      if (this.membershipdiscount == false) {
        checkmembership = "";
      } else {
        checkmembership = "/abo";
      }

      var vm = this;
      const config = {
        mode: "cors",
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "GET, POST, PATCH, PUT, DELETE, OPTIONS",
          "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token"
        }
      };

      axios
        .get("https://drupal.hairbeautycompany.nl/api/actie/bijbehandeling" + checkmembership + "?_format=json", config)

        .then(response => {
          console.log(response);
          console.log("https://drupal.hairbeautycompany.nl/api/actie/bijbehandeling" + checkmembership + "?_format=json");

          vm.loadedTreatments_discounts = response.data;
          this.wolfload = false;
        })
        .catch(error => {
          console.log(error);
        });
    },

    getTreatment_pins(pintrestlink) {
      this.wolfload_pic = true;
      this.showcarousel = false;
      this.pins = [];
      if (pintrestlink != "") {
        axios
          .get("https://api.pinterest.com/v3/pidgets/boards/" + pintrestlink + "/pins/")
          //axios.get(this.selectedTreatment.field_pintrest_rss, config)
          .then(response => {
            this.selected_treatmentpins = response.data;

            for (let [index, value] of this.selected_treatmentpins.data.pins.entries()) {
              // vm.pins.push({src: vm.selected_treatmentpins.data.pins[index].images['237x'].url.replace("237x", "736x")})
              this.pins.push({
                src: this.selected_treatmentpins.data.pins[index].images["237x"].url
              });
            }
          })
          .then(() => {
            this.showcarousel = true;
            this.wolfload_pic = false;
          })
          .catch(error => {
            console.error(error);
          });
      }
    },

    DeSelectedTreatments() {
      //Radiobox deselect
      this.$store.state.selectedTreatment_discount.Treatment_discount = 0;
      this.$store.state.selectedTreatment_discount.Treatment_discount_result = 0;
      this.$store.state.selectedTreatment_discount.Treatment_discount_name = "";
      this.killradio = false;
      this.selected_discount = this.noradio; //Throws object to another object
    },

    killradio_switch() {
      this.killradio = true;
    },

    computeSelectedTreatments() {
      //Array foreach and convert to number with ForEach function. += operator for sum
      var sumTitleTreatment = [];
      var sumPrijshoofdbehandeling = 0;

      this.selected.forEach(element => {
        console.log(element.field_prijs_behandeling);

        // sumTitleTreatment  += `${element.title} `

        sumTitleTreatment.push(element.title);
        sumPrijshoofdbehandeling += Number(element.field_prijs_behandeling); //Sums the selected prices

        console.log(sumTitleTreatment);
      });
      this.$store.state.TreatmentCalc.TitleTreatment = sumTitleTreatment;
      this.$store.state.TreatmentCalc.prijshoofdbehandeling = sumPrijshoofdbehandeling; //store the prices to VUEX
      // omschrijving nog toevoegen
      console.log(sumTitleTreatment);
    },

    computeSelectedTreatments_discount() {
      // Bereken actie met Euros of Percentage

      // Checkt de membership status

      var membershipcheck;
      if (this.membershipdiscount === false) {
        var membershipcheck = this.$store.state.TreatmentCalc.prijshoofdbehandeling;
      } else {
        var membershipcheck = this.$store.state.TreatmentCalc.prijshoofdbehandeling_abo;
      }

      let discountcalc; //Euros or Percentage?

      if (this.selected_discount.field_korting_type == "Bedrag") {
        let bedrag;
        let bedragcalc;

        this.$store.state.selectedTreatment_discount.Treatment_discount = Number(
          this.selected_discount.field_korting_in_euro
        );

        bedrag = Number(this.selected_discount.field_korting_in_euro);
        bedragcalc = membershipcheck - bedrag;

        this.$store.state.selectedTreatment_discount.Treatment_discount_result = bedragcalc;
        //Schijft de uiteindelijke percentage berekening naar de Vuex state.

        //Resultaat met gekozen Merk actie in Vuex state zetten
        this.$store.state.selectedTreatment_discount.Treatment_discount_name =
          this.selected_discount.title + " " + this.selected_discount.field_merken_actie;
      } else {
        let percentage;
        let percentagecalc;
        let naamdiscountresultaat;

        // Gooit bedrag naar Vuex State
        // this.$store.state.selectedTreatment_discount.Treatment_discount = Number(this.selected_discount.field_korting_in_percentage)

        percentage = (Number(this.selected_discount.field_korting_in_percentage) / 100) * membershipcheck; //Percentage uitrekenen

        this.$store.state.selectedTreatment_discount.Treatment_discount = percentage; //Schijft de uiteindelijke percentage berekening naar de Vuex state.

        //Resultaat met gekozen Merk actie in Vuex state zetten
        this.$store.state.selectedTreatment_discount.Treatment_discount_name =
          this.selected_discount.title + " " + this.selected_discount.field_merken_actie;
      }
    },
    getTreatments(hairlength) {
      this.wolfload = true;
      var vm = this;
      console.log("https://drupal.hairbeautycompany.nl/api/treatment/" + hairlength + "?_format=json");

      const config = {
        mode: "cors",
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "GET, POST, PATCH, PUT, DELETE, OPTIONS",
          "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token"
        }
      };

      axios
        .get("https://drupal.hairbeautycompany.nl/api/treatment/" + hairlength + "?_format=json", config)

        .then(response => {
          console.log(response);

          vm.treatments = response.data;
          // vm.selectedTreatment.title = vm.treatments[0].title;
          // vm.selectedTreatment.field_omschrijving_behandeling =
          //   vm.treatments[0].field_omschrijving_behandeling;
          // vm.selectedTreatment.field_prijs_behandeling = vm.treatments[0].field_prijs_behandeling;
          // vm.selectedTreatment.field_aanbevolen_behandeling =
          //   vm.treatments[0].field_aanbevolen_behandeling;
        })
        .then(() => {
          //Gevens binnen dan pintrest ophalen
          // vm.getTreatment_pins(vm.treatments[0].field_pintrest_rss.replace(/^\/|\/$/g, ""));
          this.wolfload = false;
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  computed: {
    computeSelectedTreatment() {
      console.log(this.selectedTreatment.title.replace("&amp;", "&"));
      return this.selectedTreatment.title.replace(/&amp;/g, "&");
    },

    //Behandeling prijs omzetten naar euros en decimalen
    computeConvertPrice() {
      let options = {
        symbol: "€",
        decimal: ",",
        thousand: ".",
        precision: 2,
        format: "%s%v"
      };

      return accounting.formatMoney(
        [
          this.$store.state.TreatmentCalc.prijshoofdbehandeling_abo, // {{computeConvertPrice[0]}} = Prijs behandeling met abo
          this.$store.state.WithTreatmentCalc.prijsbehandeling, // {{computeConvertPrice[1]}} = Prijs bijbehandeling
          this.$store.state.selectedWithTreatment_discount.WithTreatment_discount_result, // {{computeConvertPrice[2]}} = Prijs bijbehandeling met korting
          this.$store.state.ProductCalc.prijsproduct, // {{computeConvertPrice[3]}} = Prijs product
          this.$store.state.selectedProduct_discount.Product_discount_result, // {{computeConvertPrice[4]}} = Prijs product met korting
          this.$store.state.selectedTreatment_discount.Treatment_discount_result // {{computeConvertPrice[5]}} = Prijs behandeling met korting over
        ],
        options
      );
    },

    computePrice() {
      let options = {
        symbol: "€",
        decimal: ",",
        thousand: ".",
        precision: 2,
        format: "%s%v"
      };

      if (this.membershipdiscount === false) {
        // Zonder korting

        let treatmeantprice = Number(this.selectedTreatment.field_prijs_behandeling);

        let withtreatmentprice = Number(this.$store.state.WithTreatmentCalc.prijsbehandeling); //Official withtreatment price

        let productprice = Number(this.$store.state.ProductCalc.prijsproduct); //Product price from Vuex

        //this.$store.state.selectedProduct_discount.Product_discount_result

        this.$store.state.priceCalculate.totalprice = treatmeantprice + withtreatmentprice + productprice; // Alle producten bij elkaar

        if (this.killradio == false) {
          //Als de discount uit staat

          var discountprice =
            this.$store.state.selectedWithTreatment_discount.WithTreatment_discount_result +
            this.$store.state.selectedProduct_discount.Product_discount_result;
        } else {
          var discountprice =
            this.$store.state.selectedTreatment_discount.Treatment_discount +
            this.$store.state.selectedWithTreatment_discount.WithTreatment_discount_result +
            this.$store.state.selectedProduct_discount.Product_discount_result;
          // var discountprice = ( this.selectedTreatment.field_prijs_behandeling - this.$store.state.selectedTreatment_discount.Treatment_discount_result) + this.$store.state.selectedWithTreatment_discount.WithTreatment_discount_result + this.$store.state.selectedProduct_discount.Product_discount_result

          console.log("actief percentage");
        }

        // let discountprice = ( this.selectedTreatment.field_prijs_behandeling - this.$store.state.selectedTreatment_discount.Treatment_discount_result) + this.$store.state.selectedWithTreatment_discount.WithTreatment_discount_result + this.$store.state.selectedProduct_discount.Product_discount_result

        let totalprofit = this.$store.state.priceCalculate.totalprice - discountprice;

        return accounting.formatMoney(
          [
            this.$store.state.priceCalculate.totalprice,
            totalprofit, // {{computePrice[1]}} Totaal prijs minus korting
            discountprice, // {{computePrice[2]}} Totaal voordeel Zonder Abo
            productprice
          ],
          options
        ); // Arrays of prices calculations {{computePrice}}
      } else {
        // Met Korting

        let membershippercentage = 0.2; // Deze gaat over het totaal bedrag

        // LET OP prijs behandeling moet een tweede field krijgen.

        let treatmeantprice = Number(this.selectedTreatment.field_prijs_behandeling);

        let withtreatmentprice = Number(this.$store.state.WithTreatmentCalc.prijsbehandeling); //Official withtreatment price

        let productprice = Number(this.$store.state.ProductCalc.prijsproduct); //Product price from Vuexx

        this.$store.state.priceCalculate.totalprice = treatmeantprice + withtreatmentprice + productprice; // Alle producten bij elkaar

        var totalprice_abo =
          this.$store.state.priceCalculate.totalprice -
          this.$store.state.priceCalculate.totalprice * membershippercentage;

        if (this.killradio == false) {
          //Als de discount uit staat

          var discountprice =
            this.selectedTreatment.field_prijs_behandeling -
            this.selectedTreatment.field_views_simple_math_field +
            this.$store.state.selectedWithTreatment_discount.WithTreatment_discount_result +
            this.$store.state.selectedProduct_discount.Product_discount_result;
        } else {
          //Berekend Totaalprijs - abonnements kosten en telt daarop de kortingen van de gekozen bij- behandelingen + producten
          var discountprice =
            this.$store.state.priceCalculate.totalprice -
            totalprice_abo +
            this.$store.state.selectedTreatment_discount.Treatment_discount +
            this.$store.state.selectedWithTreatment_discount.WithTreatment_discount_result +
            this.$store.state.selectedProduct_discount.Product_discount_result;

          console.log("discount price" + discountprice);
        }

        // let discountprice = (this.selectedTreatment.field_prijs_behandeling - this.selectedTreatment.field_views_simple_math_field - this.$store.state.selectedTreatment_discount.Treatment_discount)
        // + this.$store.state.selectedWithTreatment_discount.WithTreatment_discount_result
        // + this.$store.state.selectedProduct_discount.Product_discount_result

        let totalprofit = this.$store.state.priceCalculate.totalprice - discountprice;

        return accounting.formatMoney(
          [
            this.$store.state.priceCalculate.totalprice,
            totalprofit,
            discountprice, // {{computePrice[2]}} Totaal voordeel met Abo
            productprice,
            totalprice_abo
          ], // {{computePrice[4]}}
          options
        );
      }
    },

    computeChooseWithTreatment() {
      //Show the array without double quotes and hooks
      var trim = this.$store.state.WithTreatmentCalc.TitleTreatment;
      return trim
        .toString()
        .replace(/[\[\]"]|\s+$/g, "")
        .replace(/,/g, ", "); //convert array to string and replace with regex.
    },
    computeChooseProduct() {
      //Show the array without double quotes and hooks
      var trim = this.$store.state.ProductCalc.TitleProduct;
      return trim
        .toString()
        .replace(/[\[\]"]|\s+$/g, "")
        .replace(/,/g, ", "); //convert array to string and replace with regex.
    },

    computeSelectedTreatments_discount_auto() {
      // Bereken actie met Euros of Percentage

      // Checkt de membership status

      var options = {
        symbol: "€",
        decimal: ",",
        thousand: ".",
        precision: 2,
        format: "%s%v"
      };

      var membershipcheck;
      if (this.membershipdiscount === false) {
        var membershipcheck = this.$store.state.TreatmentCalc.prijshoofdbehandeling;
      } else {
        var membershipcheck = this.$store.state.TreatmentCalc.prijshoofdbehandeling_abo;
      }

      let discountcalc; //Euros or Percentage?

      if (this.selected_discount.field_korting_type == "Bedrag") {
        let bedrag;
        let bedragcalc;

        this.$store.state.selectedTreatment_discount.Treatment_discount = Number(
          this.selected_discount.field_korting_in_euro
        );

        bedrag = Number(this.selected_discount.field_korting_in_euro);
        bedragcalc = membershipcheck - bedrag;

        this.$store.state.selectedTreatment_discount.Treatment_discount_result = bedragcalc;
        //Schijft de uiteindelijke percentage berekening naar de Vuex state.

        //Resultaat met gekozen Merk actie in Vuex state zetten
        this.$store.state.selectedTreatment_discount.Treatment_discount_name =
          this.selected_discount.title + " " + this.selected_discount.field_merken_actie;
      } else {
        let percentage;
        let percentagecalc;
        let naamdiscountresultaat;

        // Gooit bedrag naar Vuex State
        // this.$store.state.selectedTreatment_discount.Treatment_discount = Number(this.selected_discount.field_korting_in_percentage)

        percentage = (Number(this.selected_discount.field_korting_in_percentage) / 100) * membershipcheck; //Percentage uitrekenen

        this.$store.state.selectedTreatment_discount.Treatment_discount_resultpercentage; //Schijft de uiteindelijke percentage berekening naar de Vuex state.

        //Resultaat met gekozen Merk actie in Vuex state zetten
        this.$store.state.selectedTreatment_discount.Treatment_discount_name =
          this.selected_discount.title + " " + this.selected_discount.field_merken_actie;
      }
    },

    companyPrimaryColor() {
      return this.$store.state.companyPrimaryColor;
    },
    companySecondaryColor() {
      return this.$store.state.companySecondaryColor;
    }
  }
};
</script>
